import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Store } from '@ngxs/store';
import { Subscription } from 'rxjs';
import { ValidationError } from '../../../../../domain/error.model';
import { ErrorAwareComponent, LsnErrorStateMatcher } from '../../../../shared/middleware/error-state-matcher';
import { DialogAction } from '../../../store/dialog.action';
import { ErrorsState } from '../../../store/errors.state';
import { OfferAction } from '../../../store/offer.action';

@Component({
    selector: 'app-location-dialog',
    templateUrl: './location-dialog.component.html',
    styleUrls: ['./location-dialog.component.scss']
})
export class LocationDialogComponent implements OnInit, OnDestroy, ErrorAwareComponent {

    location: string;
    calculationId: number;

    subscriptions: Subscription[] = [];
    errors: ValidationError[];
    matchers = {
        location: new LsnErrorStateMatcher(this, 'location'),
    };

    constructor(private store: Store,
                @Inject(MAT_DIALOG_DATA) data) {
        this.location = data.location;
        this.calculationId = data.calculationId;
    }

    ngOnInit(): void {
        this.subscriptions.push(
            this.store.select(ErrorsState.getAsideErrors).subscribe(errors => this.errors = errors),
        );
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(s => s.unsubscribe());
    }


    save() {
        this.store.dispatch(new OfferAction.SaveLocation(this.calculationId, this.location));
    }

    cancel() {
        this.store.dispatch(new DialogAction.CloseAll());
    }
}
